/**
 * Aluno Conectado — Sistema Autônomo de Diagnósticos e Conectividade
 * Executa testes de integridade sem depender de bibliotecas externas.
 */
export async function runDiagnostics() {
  const root = document.getElementById('root');
  if (!root) return;

  // Injetar layout de tela dividida (split screen) que cabe exatamente no viewport
  root.innerHTML = `
    <div id="diag-console" style="
      background-color: #0c0214;
      color: #cbd5e1;
      font-family: 'Outfit', 'Inter', sans-serif;
      padding: 20px;
      height: 100vh;
      max-height: 100vh;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-size: 14px;
      line-height: 1.6;
    ">
      <!-- Cabeçalho -->
      <div style="border-bottom: 2px solid #8b5cf6; padding-bottom: 12px; margin-bottom: 16px; flex-shrink: 0; display: flex; justify-content: space-between; align-items: center;">
        <div>
          <h1 style="margin: 0; font-size: 20px; color: #a78bfa; font-weight: bold; letter-spacing: 1px;">
            🛡️ ALUNO CONECTADO — DIAGNOSTICS UTILITY
          </h1>
          <p style="margin: 4px 0 0 0; color: #64748b; font-size: 12px;">
            Painel ativo de integridade operacional, conexões e conformidade de banco de dados.
          </p>
        </div>
        <div style="background-color: #1e1b4b; border: 1px solid #4c1d95; padding: 4px 12px; border-radius: 4px; font-size: 11px; color: #a78bfa; font-family: monospace;">
          MODE: E2E DIAGNOSTIC ACTIVE
        </div>
      </div>

      <!-- Área de Conteúdo Dividida (Split Screen) -->
      <div style="display: flex; gap: 20px; flex: 1; min-height: 0; margin-bottom: 16px;">
        
        <!-- Lado Esquerdo: Checklist de Integridade -->
        <div style="flex: 1.1; display: flex; flex-direction: column; background-color: #12071f; border: 1px solid #3b1682; border-radius: 8px; padding: 16px; min-height: 0;">
          <div style="border-bottom: 1px solid #2e1065; padding-bottom: 8px; margin-bottom: 12px; color: #a78bfa; font-weight: bold; font-size: 13px; flex-shrink: 0;">
            📋 RESULTADOS DE CHECAGEM
          </div>
          
          <div id="checklist-scroll-container" style="flex: 1; overflow-y: auto; padding-right: 6px;">
            <!-- Ambiente do Dispositivo -->
            <div style="background-color: #0b0312; border: 1px solid #2e1065; padding: 12px; border-radius: 6px; margin-bottom: 16px; font-size: 12px; font-family: monospace;">
              <strong>Ambiente do Dispositivo:</strong><br>
              <span style="color: #64748b;">UserAgent:</span> ${navigator.userAgent}<br>
              <span style="color: #64748b;">Timezone:</span> ${Intl.DateTimeFormat().resolvedOptions().timeZone}<br>
              <span style="color: #64748b;">Hora Local:</span> ${new Date().toLocaleString()}<br>
              <span style="color: #64748b;">Plataforma:</span> ${navigator.platform}
            </div>

            <div>
              <strong style="color: #a78bfa; font-size: 13px; display: block; margin-bottom: 8px;">Checagens ativas:</strong>
              <ul id="diag-list" style="list-style: none; padding: 0; margin: 0;">
                <li id="test-storage" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de armazenamento local (Storage)...</li>
                <li id="test-pwa" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de compatibilidade PWA...</li>
                <li id="test-webauthn" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de biometria / Passkey...</li>
                <li id="test-fcm" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de canal Push FCM...</li>
                <li id="test-cookie" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de Cookie de Sessão (__session)...</li>
                <li id="test-ping" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de latência de rede...</li>
                <li id="test-backend" style="margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px dashed #221535;">⏳ Teste de conexão com API (Backend)...</li>
                <li id="test-e2e" style="margin-bottom: 8px;">⏳ Teste de fluxo E2E (Autenticação, Banco e Transação)...</li>
              </ul>
            </div>

            <!-- Resumo -->
            <div id="diag-summary" style="
              display: none;
              background-color: #10061a;
              border-left: 4px solid #10b981;
              padding: 12px;
              border-radius: 4px;
              margin-top: 16px;
              font-size: 13px;
            ">
              <strong style="color: #34d399; font-size: 14px;">✅ Diagnóstico Concluído</strong><br>
              <p id="diag-summary-text" style="margin: 4px 0 0 0; color: #cbd5e1;"></p>
            </div>
          </div>
        </div>

        <!-- Lado Direito: Terminal Real-Time Output -->
        <div style="flex: 1; display: flex; flex-direction: column; background-color: #05010a; border: 1px solid #2e1065; border-radius: 8px; padding: 16px; min-height: 0;">
          <div style="border-bottom: 1px solid #2e1065; padding-bottom: 8px; margin-bottom: 10px; color: #a78bfa; font-weight: bold; font-size: 13px; display: flex; justify-content: space-between; align-items: center; flex-shrink: 0; font-family: sans-serif;">
            <span>💻 REAL-TIME TERMINAL OUTPUT</span>
            <button id="btn-clear-term" style="
              background-color: #1e1b4b;
              border: 1px solid #4c1d95;
              color: #a78bfa;
              font-size: 11px;
              padding: 3px 8px;
              border-radius: 4px;
              cursor: pointer;
              font-family: inherit;
              transition: all 0.2s;
            ">Limpar</button>
          </div>
          <div id="diag-terminal-stream" style="
            flex: 1;
            overflow-y: auto;
            background-color: #020005;
            border: 1px solid #1a0836;
            border-radius: 4px;
            padding: 12px;
            font-family: 'Consolas', 'Courier New', monospace;
            font-size: 12px;
            line-height: 1.5;
            color: #e2e8f0;
            white-space: pre-wrap;
            box-shadow: inset 0 0 10px rgba(0,0,0,0.8);
          "></div>
        </div>

      </div>

      <!-- Rodapé / Ações -->
      <div style="display: flex; gap: 12px; border-top: 1px solid #2e1065; padding-top: 16px; flex-shrink: 0;">
        <button id="btn-recheck" style="
          background-color: #3b1682;
          color: white;
          border: 1px solid #8b5cf6;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-family: inherit;
          font-weight: bold;
          transition: all 0.2s;
        ">🔄 Repetir Testes</button>
        
        <button id="btn-continue" style="
          background-color: #10b981;
          color: #064e3b;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-family: inherit;
          font-weight: bold;
          transition: all 0.2s;
        ">🚪 Ir Para a Aplicação</button>
      </div>
    </div>
  `;

  // Referências dos Elementos
  const diagList = {
    storage: document.getElementById('test-storage')!,
    pwa: document.getElementById('test-pwa')!,
    webauthn: document.getElementById('test-webauthn')!,
    fcm: document.getElementById('test-fcm')!,
    cookie: document.getElementById('test-cookie')!,
    ping: document.getElementById('test-ping')!,
    backend: document.getElementById('test-backend')!,
    e2e: document.getElementById('test-e2e')!
  };
  const termEl = document.getElementById('diag-terminal-stream')!;
  const checkScrollEl = document.getElementById('checklist-scroll-container')!;
  const summary = document.getElementById('diag-summary')!;
  const summaryText = document.getElementById('diag-summary-text')!;

  // Funções utilitárias de log estilo Terminal Real
  const logCommand = (cmd: string) => {
    if (!termEl) return;
    const isAtBottom = termEl.scrollHeight - termEl.clientHeight <= termEl.scrollTop + 30;
    termEl.innerHTML += `<span style="color: #38bdf8;">euler@alunoconectado:~$</span> <span style="color: #ffffff; font-weight: bold;">${cmd}</span>\n`;
    if (isAtBottom) termEl.scrollTop = termEl.scrollHeight;
  };

  const logRaw = (text: string, color: string = '#cbd5e1') => {
    if (!termEl) return;
    const isAtBottom = termEl.scrollHeight - termEl.clientHeight <= termEl.scrollTop + 30;
    termEl.innerHTML += `<span style="color: ${color};">${text}</span>\n`;
    if (isAtBottom) termEl.scrollTop = termEl.scrollHeight;
  };

  // Funções utilitárias do console do navegador (para auditorias de dev)
  const logOk = (label: string, info: string) => {
    console.log(`%c[OK] ${label}: %c${info}`, 'color: #10b981; font-weight: bold;', 'color: #e2e8f0;');
  };
  const logErr = (label: string, info: string) => {
    console.warn(`%c[FALHA] ${label}: %c${info}`, 'color: #ef4444; font-weight: bold;', 'color: #fca5a5;');
  };

  // Limpar Terminal
  document.getElementById('btn-clear-term')!.addEventListener('click', () => {
    if (termEl) termEl.innerHTML = '';
  });

  console.group('%c🛡️ ALUNO CONECTADO - RELATÓRIO DE INTEGRIDADE DO FRONTEND', 'color: #a78bfa; font-size: 14px; font-weight: bold;');

  let failuresCount = 0;

  // 1. Teste de Storage (LocalStorage/SessionStorage)
  logCommand('npm run test:storage --silent');
  logRaw('Verifying storage availability in window scope...', '#94a3b8');
  try {
    localStorage.setItem('ac_diag_test', '1');
    localStorage.removeItem('ac_diag_test');
    sessionStorage.setItem('ac_diag_test', '1');
    sessionStorage.removeItem('ac_diag_test');
    diagList.storage.innerHTML = '✅ <span style="color: #34d399;">Storage:</span> LocalStorage e SessionStorage acessíveis.';
    logOk('Storage', 'Acesso e persistência temporária no armazenamento local estão operacionais.');
    logRaw('localStorage capacity: OK\nsessionStorage capacity: OK\nExit code: 0', '#34d399');
  } catch (err: any) {
    failuresCount++;
    diagList.storage.innerHTML = '❌ <span style="color: #f87171;">Storage:</span> Acesso ao Storage negado pelo navegador (cookies de terceiros ou modo anônimo estrito).';
    logErr('Storage', `Falha ao ler/escrever no storage: ${err.message}`);
    logRaw(`ERROR: Storage write test failed: ${err.message}\nExit code: 1`, '#f87171');
  }
  logRaw('\n');

  // 2. Teste de compatibilidade PWA
  logCommand('check-service-worker --detect');
  logRaw("Checking 'serviceWorker' support in window.navigator...", '#94a3b8');
  if ('serviceWorker' in navigator) {
    diagList.pwa.innerHTML = '✅ <span style="color: #34d399;">PWA SW:</span> Suporte a Service Worker ativo no navegador.';
    logOk('PWA SW', 'Navegador suporta instalação de Service Worker offline-first.');
    logRaw('navigator.serviceWorker container detected: ACTIVE\nExit code: 0', '#34d399');
  } else {
    diagList.pwa.innerHTML = '⚠️ <span style="color: #fbbf24;">PWA SW:</span> Navegador sem suporte a Service Worker (offline-first inativo).';
    logRaw('WARNING: serviceWorker is not supported in this browser environment.\nExit code: 0', '#fbbf24');
  }
  logRaw('\n');

  // 3. Teste de Biometria / WebAuthn
  logCommand('check-authenticator-availability');
  logRaw('Querying PublicKeyCredential interface...', '#94a3b8');
  if (window.PublicKeyCredential) {
    diagList.webauthn.innerHTML = '✅ <span style="color: #34d399;">Passkeys:</span> Hardware de chaves biométricas/Passkeys disponível.';
    logOk('Passkeys', 'WebAuthn API suportada pelo navegador.');
    logRaw('PublicKeyCredential support: AVAILABLE\nExit code: 0', '#34d399');
  } else {
    diagList.webauthn.innerHTML = '⚠️ <span style="color: #fbbf24;">Passkeys:</span> API WebAuthn indisponível neste navegador/dispositivo.';
    logRaw('WARNING: PublicKeyCredential is not available in global window context.\nExit code: 0', '#fbbf24');
  }
  logRaw('\n');

  // 4. Teste de Push FCM
  logCommand('query-notification-permission');
  logRaw('Querying browser Notification permission state...', '#94a3b8');
  if ('Notification' in window && 'serviceWorker' in navigator) {
    const status = Notification.permission;
    diagList.fcm.innerHTML = `✅ <span style="color: #34d399;">Push FCM:</span> Permissão de notificação: <strong>${status}</strong>.`;
    logOk('Push FCM', `API de notificação disponível. Status atual: ${status}`);
    logRaw(`Notification permission status: "${status}"\nExit code: 0`, '#34d399');
  } else {
    diagList.fcm.innerHTML = '⚠️ <span style="color: #fbbf24;">Push FCM:</span> Notificações Push não suportadas pelo navegador.';
    logRaw('WARNING: Notification API is not supported in this browser.\nExit code: 0', '#fbbf24');
  }
  logRaw('\n');

  // 5. Teste de Cookie de Sessão
  logCommand('cat /proc/cookies | grep __session');
  logRaw('Searching cookies in document.cookie scope...', '#94a3b8');
  const hasSessionCookie = document.cookie.includes('__session');
  if (hasSessionCookie) {
    diagList.cookie.innerHTML = '✅ <span style="color: #34d399;">Sessão Cookie:</span> Cookie composto <strong>__session</strong> presente no navegador.';
    logOk('Sessão Cookie', 'Cookie composto __session identificado no armazenamento de cabeçalhos.');
    logRaw('__session: FOUND (Session cookie exists)\nExit code: 0', '#34d399');
  } else {
    diagList.cookie.innerHTML = '⚠️ <span style="color: #fbbf24;">Sessão Cookie:</span> Cookie <strong>__session</strong> ausente (usuário não logado ou cookies apagados).';
    logRaw('WARNING: Cookie "__session" was not found in document.cookie.\nExit code: 1', '#fbbf24');
  }
  logRaw('\n');

  // 6. Teste de latência de rede (Ping)
  const startPing = Date.now();
  logCommand(`ping -n 1 -w 1000 cdn.alunoconectado.com.br`);
  logRaw('Pinging cdn.alunoconectado.com.br with 32 bytes of data:', '#94a3b8');
  try {
    await fetch(`/icons/logo-pwa-white.svg?cb=${startPing}`);
    const latency = Date.now() - startPing;
    diagList.ping.innerHTML = `✅ <span style="color: #34d399;">Rede Latência:</span> Latência média medida com CDN: <strong>${latency}ms</strong>.`;
    logOk('Rede Latência', `Ping concluído com sucesso. Latência: ${latency}ms.`);
    logRaw(`Reply from cdn.alunoconectado.com.br: bytes=32 time=${latency}ms TTL=56\n\nPing statistics:\n    Packets: Sent = 1, Received = 1, Lost = 0 (0% loss)\nExit code: 0`, '#34d399');
  } catch (err: any) {
    failuresCount++;
    diagList.ping.innerHTML = '❌ <span style="color: #f87171;">Rede Latência:</span> Falha crítica de conexão de rede ou bloqueio de CORS.';
    logErr('Rede Latência', `Falha ao medir latência de rede: ${err.message}`);
    logRaw(`Ping request failed: ${err.message}\nExit code: 1`, '#f87171');
  }
  logRaw('\n');

  // 7. Teste de conexão com API (Backend)
  const startBackend = Date.now();
  logCommand('curl -i -X GET http://localhost:3443/health/ready');
  logRaw('Connecting to remote API endpoint /health/ready...', '#94a3b8');
  try {
    const res = await fetch('/health/ready');
    const latency = Date.now() - startBackend;
    if (res.status === 200) {
      const dataText = await res.text();
      diagList.backend.innerHTML = `✅ <span style="color: #34d399;">API Backend:</span> Conexão ao servidor ativa (Status: 200, Latência: <strong>${latency}ms</strong>).`;
      logOk('API Backend', `Conexão bem-sucedida ao endpoint /health/ready em ${latency}ms.`);
      logRaw(`HTTP/1.1 200 OK\nContent-Type: application/json; charset=utf-8\nLatency: ${latency}ms\n\n${dataText}\nExit code: 0`, '#34d399');
    } else {
      failuresCount++;
      const errText = await res.text();
      diagList.backend.innerHTML = `❌ <span style="color: #f87171;">API Backend:</span> Servidor respondeu com código de erro HTTP: <strong>${res.status}</strong>.`;
      logErr('API Backend', `Servidor retornou erro status ${res.status}`);
      logRaw(`HTTP/1.1 ${res.status} Error\nContent-Type: application/json\n\n${errText}\nExit code: 1`, '#f87171');
    }
  } catch (err: any) {
    failuresCount++;
    diagList.backend.innerHTML = '❌ <span style="color: #f87171;">API Backend:</span> Servidor backend inalcançável ou offline (Erro de Conexão).';
    logErr('API Backend', `Exceção ao conectar no backend: ${err.message}`);
    logRaw(`curl: (7) Failed to connect to localhost port 3443: Connection refused\nExit code: 7`, '#f87171');
  }
  logRaw('\n');

  // 8. Teste E2E Backend Completo (Gravação, Recuperação, Login, Exclusão transacional)
  logCommand('curl -i -X GET http://localhost:3443/health/run-e2e-diagnostics');
  logRaw('Initializing complete E2E transactional connection run...', '#94a3b8');
  try {
    const res = await fetch('/health/run-e2e-diagnostics');
    const dataText = await res.text();
    
    let parsedData: any = null;
    try {
      parsedData = JSON.parse(dataText);
    } catch {}

    if (res.status === 200 && parsedData && parsedData.ok) {
      let subListHtml = '<ul style="margin: 6px 0 0 20px; padding: 0; list-style: none; font-size: 12px; color: #94a3b8; font-family: inherit;">';
      parsedData.results.forEach((r: any) => {
        const marker = r.status === 'success' ? '├─ ✅' : r.status === 'skipped' ? '├─ ⚠️' : '├─ ❌';
        const color = r.status === 'success' ? '#34d399' : r.status === 'skipped' ? '#fbbf24' : '#f87171';
        subListHtml += `<li style="margin-bottom: 4px;">${marker} <span style="color: ${color};">${r.step}:</span> ${r.detail}</li>`;
      });
      subListHtml += '</ul>';

      diagList.e2e.innerHTML = `✅ <span style="color: #34d399;">Fluxo E2E:</span> Integração e transação concluídas com sucesso. ${subListHtml}`;
      logOk('Fluxo E2E', 'Operações de registro, autenticação e banco finalizadas com sucesso (Zero Resíduos).');
      logRaw(`HTTP/1.1 200 OK\nContent-Type: application/json; charset=utf-8\n\n${JSON.stringify(parsedData, null, 2)}\nExit code: 0`, '#34d399');
    } else {
      failuresCount++;
      const detailMsg = parsedData?.results?.find((r: any) => r.status === 'error')?.detail || 'Falha desconhecida';
      
      let subListHtml = '<ul style="margin: 6px 0 0 20px; padding: 0; list-style: none; font-size: 12px; color: #f87171; font-family: inherit;">';
      if (parsedData && parsedData.results) {
        parsedData.results.forEach((r: any) => {
          const marker = r.status === 'success' ? '├─ ✅' : '├─ ❌';
          subListHtml += `<li style="margin-bottom: 4px;">${marker} <span>${r.step}:</span> ${r.detail}</li>`;
        });
      }
      subListHtml += '</ul>';

      diagList.e2e.innerHTML = `❌ <span style="color: #f87171;">Fluxo E2E:</span> Falha crítica no fluxo: ${subListHtml}`;
      logErr('Fluxo E2E', `Erro no fluxo E2E: ${detailMsg}`);
      
      const rawReport = parsedData ? JSON.stringify(parsedData, null, 2) : dataText;
      logRaw(`HTTP/1.1 ${res.status} Internal Error\nContent-Type: application/json\n\n${rawReport}\nExit code: 1`, '#f87171');
    }
  } catch (err: any) {
    failuresCount++;
    diagList.e2e.innerHTML = `❌ <span style="color: #f87171;">Fluxo E2E:</span> Falha de conexão na execução do fluxo: ${err.message}`;
    logErr('Fluxo E2E', `Erro de requisição: ${err.message}`);
    logRaw(`curl: (52) Empty reply from server or connection crash: ${err.message}\nExit code: 52`, '#f87171');
  }

  console.groupEnd();
  logRaw('\n');
  logRaw('========================================================', '#a78bfa');
  logRaw(`DIAGNOSTIC PIPELINE FINISHED WITH ${failuresCount} CRITICAL ERRORS`, failuresCount === 0 ? '#34d399' : '#f87171');
  logRaw('========================================================', '#a78bfa');

  // Exibir resumo do diagnóstico
  summary.style.display = 'block';

  if (failuresCount === 0) {
    summary.style.borderLeftColor = '#10b981';
    summary.style.backgroundColor = '#0b1f15';
    summaryText.innerHTML = 'A integridade das conexões e armazenamento está <strong>100% íntegra</strong>. Nenhuma anomalia crítica foi encontrada no carregamento básico. O sistema está pronto para execução.';
  } else {
    summary.style.borderLeftColor = '#ef4444';
    summary.style.backgroundColor = '#1f0b0b';
    summaryText.style.color = '#fca5a5';
    summaryText.innerHTML = `Foram identificados <strong>${failuresCount} problemas críticos</strong> na checagem. Verifique as falhas marcadas em vermelho acima e consulte o console do desenvolvedor para ver os erros completos.`;
  }

  // Rolagem automática final para o container do checklist caso precise
  if (checkScrollEl) {
    checkScrollEl.scrollTop = checkScrollEl.scrollHeight;
  }

  // Comportamento dos botões
  document.getElementById('btn-recheck')!.addEventListener('click', () => {
    runDiagnostics();
  });

  document.getElementById('btn-continue')!.addEventListener('click', () => {
    // Redirecionar retirando a query string ?check=1
    const cleanUrl = window.location.origin + window.location.pathname;
    window.location.href = cleanUrl;
  });
}
